export const sanitizeCode = (input) => {
	if (typeof input !== "string") {
		throw new Error("Input must be string")
	}

	return input
		.replace(/[^\w]+/g, "") // replace all non (^) alphanum by ""
		.toUpperCase()
}
